import { render } from "./DeviceComponent.vue?vue&type=template&id=33bdbf52"
import script from "./DeviceComponent.vue?vue&type=script&lang=js"
export * from "./DeviceComponent.vue?vue&type=script&lang=js"

import "./DeviceComponent.vue?vue&type=style&index=0&id=33bdbf52&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__